import { FC, useState } from 'react';
import { Box, BoxProps, Flex, IconButton } from '@chakra-ui/react';
import { CbTableSearchbar } from '../CbTable/CbTableSearchbar';
import { CbFilterBox } from '../CbFilterBox';
import Search from '../Icons/Search';
import Close from '../Icons/Close';
import FilterOutline from '../Icons/FilterOutline';
export interface CbMobileDirectorySearchProps extends BoxProps {
  activeFilters: string[] | null;
  defaultValue?: string;
  dropdownFilters: string[];
  handleSearchFilter: (search: string) => void;
  handleActiveFilterChange: (filters: string[]) => void;
  onSearchClose: () => void;
  onFilterClose: () => void;
}
export const CbMobileDirectorySearch: FC<CbMobileDirectorySearchProps> = ({
  activeFilters,
  defaultValue,
  handleActiveFilterChange,
  handleSearchFilter,
  dropdownFilters,
  onSearchClose,
  onFilterClose,
  ...props
}) => {
  const [showSearch, setShowSearch] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  return <Box {...props} data-sentry-element="Box" data-sentry-component="CbMobileDirectorySearch" data-sentry-source-file="CbMobileDirectorySearch.tsx">
      <Flex justifyContent="flex-end" data-sentry-element="Flex" data-sentry-source-file="CbMobileDirectorySearch.tsx">
        <IconButton _focus={{
        outline: 'none'
      }} borderRadius={100} borderWidth="2px" borderColor="white" colorScheme={showSearch ? 'gray' : 'whiteAlpha'} marginRight={2} aria-label="search" onClick={() => {
        setShowSearch(!showSearch);
        setShowFilters(false);
        showSearch && onSearchClose();
      }} data-sentry-element="IconButton" data-sentry-source-file="CbMobileDirectorySearch.tsx">
          {showSearch ? <Close /> : <Search />}
        </IconButton>
        <IconButton _focus={{
        outline: 'none'
      }} borderRadius={100} borderWidth="2px" borderColor="white" colorScheme={showFilters ? 'gray' : 'whiteAlpha'} aria-label="search" onClick={() => {
        setShowFilters(!showFilters);
        setShowSearch(false);
        showFilters && onFilterClose();
      }} data-sentry-element="IconButton" data-sentry-source-file="CbMobileDirectorySearch.tsx">
          {showFilters ? <Close /> : <FilterOutline />}
        </IconButton>
      </Flex>
      {showSearch && <Box marginTop={3}>
          <CbTableSearchbar onTextFilterChange={text => handleSearchFilter(text)} defaultValue={defaultValue} backgroundColor="cloud.100" borderColor="cloud.300" />
        </Box>}
      {showFilters && <Box marginTop={3}>
          <CbFilterBox staleFilters={activeFilters} backgroundColor="white" padding={4} borderRadius={24} boxShadow="standardCard" dropdownFilters={dropdownFilters} handleActiveFilterChange={handleActiveFilterChange} />
        </Box>}
    </Box>;
};